// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__1dPCw","header":"MessagesList_header__3Rh6Z","chat":"MessagesList_chat__2Q0HQ"};